var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRaspberry = function SvgRaspberry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#raspberry_svg__a)",
    d: "M160.84 83.3c6.03.06 19.04 5.28 16.93 14.42-2.1 9.13-14.36 28.54-39.47 28.27-25.11-.26-53.15-8.92-50.07-16 2.72-6.25 8.17-12.12 16.2-12.04 2.06-5.06 6.57-6.03 10.84-4.97 2.57-3.02 4.96-4.01 8.65-2.96 1.41-3.03 3.76-6.06 9.78-4.98 2.04-3.03 5.24-2.99 7.66-2.97 3.26-2 13.51-3.92 19.48 1.23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#raspberry_svg__b)",
    d: "M110.96 115.09c-19.85-17.94-39.69-1.99-30.76 14.95 0 0-3.97 14.95 9.92 24.92 0 0-.99 10.96 8.93 12.96 0 0 2.98 14.95 17.86 13.95 0 0 7.94 8.97 18.85 5.98 0 0 10.92 5.98 19.85-1.99 0 0 10.92 0 14.88-7.97 0 0 6.95-1.99 6.95-10.96 0 0 4.96-1 5.95-9.97 0 0 11.91-6.98 5.95-19.93 0 0 5.95-7.66 0-16.79 0 0 .99-5.14-3.97-9.13 2.98-15.95-25.22-31.85-32.46-3.47 0 0-1.91.73-1.59 1.6 0 0-2.66.87-2.66 1.87 0 0-2.98 0-3.97 1.99 0 0-5.95-2.99-12.9 1 0 0-7.94-3.99-20.84 1z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "raspberry_svg__a",
    x1: 134.4,
    x2: 131.52,
    y1: 127.65,
    y2: 77.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#1A88BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#4DA3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#7ABAD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#A0CEE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#BFDEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D8EBF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E9F4F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3F9FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "raspberry_svg__b",
    x1: 135,
    x2: 135,
    y1: 188.13,
    y2: 94.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#1988BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#238DBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#3E9BC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#6AB1D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#A6D1E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#F3F9FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })))));
};
export default SvgRaspberry;